import React from 'react';
import { Routes, BrowserRouter as Router, Route, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers';
import CompetenciesPage from './pages/CompetenciesPage';
import LoginPage from './pages/LoginPage';
import SwipesPage from './pages/SwipesPage';
import SpotCheck from './pages/SpotCheckPage';
import ProgressDialog from './components/ProgressDialog';
import { initTheme, defaultTheme } from './themes';
import isEmptyObject from './utilities/is/isEmptyObject';
import BrowserSupport from './components/BrowserSupport';
import RequireAuth from 'components/RequireAuth';

import { appInsightsService } from "./utilities/logging/appInsightsService";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";

const fallbackTheme = defaultTheme();

function getFaviconElement() {
    return document.getElementById("favicon");
}

class App extends React.Component { 

    render() {
        const { loadingConfig, theme } = this.props;

        const favicon = getFaviconElement();
        favicon.href = theme.themeName + "/favicon.ico";

        return (
            // <React.StrictMode>
            <AppInsightsErrorBoundary onError={() => <h1>An error has occurred</h1>} appInsights={appInsightsService.reactPlugin}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <StyledEngineProvider injectFirst>
                        <BrowserSupport>
                            <LocalizationProvider dateAdapter={AdapterLuxon}>
                                <ProgressDialog open={loadingConfig}>
                                    Loading initial configuration, please wait..
                                </ProgressDialog>
                                <Router>
                                    <Routes>
                                        <Route path="/" element={
                                            <RequireAuth redirectTo="/login" requirements="swipes" alt="/spotCheck">
                                                <SwipesPage />
                                            </RequireAuth>
                                        }
                                        />
                                        <Route path="/swipes" element={
                                            <RequireAuth redirectTo="/login" requirements="swipes" alt="/spotCheck">
                                                <SwipesPage />
                                            </RequireAuth>
                                        }
                                        />
                                        <Route path="/spotCheck" element={
                                            <RequireAuth redirectTo="/login" requirements="spotCheck" >
                                                <SpotCheck />
                                            </RequireAuth>
                                        }
                                        />
                                        <Route path="/competencies" element={
                                            <RequireAuth redirectTo="/login" requirements="swipes" alt="/spotCheck" >
                                                <CompetenciesPage />
                                            </RequireAuth>
                                        }
                                        />
                                        <Route path="/login" element={<LoginPage />} />
                                        <Route path="*" render={() => <Navigate to="/" />} />
                                    </Routes>
                                </Router>
                            </LocalizationProvider>
                        </BrowserSupport>
                    </StyledEngineProvider>
                </ThemeProvider>
            </AppInsightsErrorBoundary>
            /* // </React.StrictMode> */
        );
    }
}

function mapStateToProps(state) {
    const { auth, config, theme } = state;
    return {
        auth,
        config,
        needsTheme: !theme || isEmptyObject(theme.theme),
        theme: theme.theme ? initTheme(theme.theme, config.theme) : fallbackTheme,
        loadingConfig: isEmptyObject(config) || config.requesting
    };
}

const connectedApp = connect(mapStateToProps)(App);

export default connectedApp;